import React from 'react';
import { Loading, hasCaption } from '../../Message';
import {
  MediaRow,
  MediaItem,
  VideoContainer,
  MediaTag,
  MediaWithoutCaption,
  MessageFooter
} from './styles';

interface MessageBodyVideoProps {
  message: any,
  mediaVideo: HTMLVideoElement | null
}

function MessageBodyVideo({ message, mediaVideo }: MessageBodyVideoProps) {
  return (
    <VideoContainer as="sdiv">
      <MediaRow as="sdiv"
        style={{
          width: '220', 
          height: mediaVideo ? `${(220 / mediaVideo?.videoWidth) * mediaVideo.videoHeight}px` : '160px'}}
        >
        <MediaItem as="sdiv">
          {(!mediaVideo || !mediaVideo.src) ?
            <Loading message={message} />
            :
            <MediaItem as="sdiv">
              <MediaTag controls preload='none'>
                <source src={mediaVideo.src} type={message.body.file.contentType} />
              </MediaTag>
            </MediaItem>
          }
          <MessageFooter />
          {!hasCaption(message) && <MediaWithoutCaption />}
        </MediaItem>
      </MediaRow>
    </VideoContainer>
  );
}

export default React.memo(MessageBodyVideo)